/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AssignMissingIndividualIncentive } from '@coin/shared/core/util-models-v2';
import { BucketComponentModificationResponse } from '@coin/shared/core/util-models-v2';
import { BucketComponentsPossibilities } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModel } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModificationResponse } from '@coin/shared/core/util-models-v2';
import { CalculateManySimulations } from '@coin/shared/core/util-models-v2';
import { CalculateSimulation } from '@coin/shared/core/util-models-v2';
import { CandidatePoolModel } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { CreateBucketComponent } from '@coin/shared/core/util-models-v2';
import { CreateCandidatePool } from '@coin/shared/core/util-models-v2';
import { CreateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { CreateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { CreateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { CreateMember } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { CreatePlan } from '@coin/shared/core/util-models-v2';
import { CreatePlanSettings } from '@coin/shared/core/util-models-v2';
import { CreatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { CreateSeason } from '@coin/shared/core/util-models-v2';
import { DuplicateIncentiveSeason } from '@coin/shared/core/util-models-v2';
import { EmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { EmployeeSeasonOverview } from '@coin/shared/core/util-models-v2';
import { EmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { ExportEmployeePopulationResultDto } from '@coin/shared/core/util-models-v2';
import { MemberModel } from '@coin/shared/core/util-models-v2';
import { MeritCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { MeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models-v2';
import { OrganisationInformationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotTreeItem } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfMember } from '@coin/shared/core/util-models-v2';
import { PageOfMeritInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfPlan } from '@coin/shared/core/util-models-v2';
import { PageOfPlanWithMissingIndividualValues } from '@coin/shared/core/util-models-v2';
import { PageOfPositionEvaluationCandidate } from '@coin/shared/core/util-models-v2';
import { PageOfRecord } from '@coin/shared/core/util-models-v2';
import { PageOfSeason } from '@coin/shared/core/util-models-v2';
import { PageOfSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PlanModel } from '@coin/shared/core/util-models-v2';
import { PlanSettingsModel } from '@coin/shared/core/util-models-v2';
import { PopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { PositionEvaluationSimulationModel } from '@coin/shared/core/util-models-v2';
import { PublicationSettingsModel } from '@coin/shared/core/util-models-v2';
import { RecordModel } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SeasonModel } from '@coin/shared/core/util-models-v2';
import { SeasonSettingsModel } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsCreateSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsUpdateSimulation } from '@coin/shared/core/util-models-v2';
import { SetSeasonSettings } from '@coin/shared/core/util-models-v2';
import { SimulationPublicationsPublishSimulation } from '@coin/shared/core/util-models-v2';
import { Snapshot } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models-v2';
import { UnPublishSimulation } from '@coin/shared/core/util-models-v2';
import { UpdateBucketComponent } from '@coin/shared/core/util-models-v2';
import { UpdateBudgetBucket } from '@coin/shared/core/util-models-v2';
import { UpdateCandidatePool } from '@coin/shared/core/util-models-v2';
import { UpdateCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshotPartial } from '@coin/shared/core/util-models-v2';
import { UpdateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { UpdateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { UpdateManyBudgetBuckets } from '@coin/shared/core/util-models-v2';
import { UpdateMember } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdatePlan } from '@coin/shared/core/util-models-v2';
import { UpdatePlanSettings } from '@coin/shared/core/util-models-v2';
import { UpdatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateSeason } from '@coin/shared/core/util-models-v2';
import { UpdateSimulationMembers } from '@coin/shared/core/util-models-v2';
import { UpdateSnapshotBenchmarkValues } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AssignKpiDetailsToRecordRecordsParams {
  recordId: string;
  /** Information about the record and kpis */
  assignMissingIndividualIncentive?: AssignMissingIndividualIncentive;
}

export interface SeasonsIncentiveAdminCalculateManySimulationParams {
  seasonId: string;
  calculateManySimulations?: CalculateManySimulations;
}

export interface SeasonsIncentiveAdminCalculateSimulationParams {
  seasonId: string;
  calculateSimulation?: CalculateSimulation;
}

export interface SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsIncentiveAdminChangePrioritiesPlansParams {
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsIncentiveAdminCreateBudgetComponentsParams {
  budgetBucketId: string;
  createBucketComponent?: CreateBucketComponent;
}

export interface SeasonsIncentiveAdminCreateCandidatePoolsParams {
  createCandidatePool?: CreateCandidatePool;
}

export interface SeasonsIncentiveAdminCreateEmployeeSnapshotsParams {
  createEmployeeSnapshot?: CreateEmployeeSnapshot;
}

export interface SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams {
  simulationId: string;
  createInformationVisibilitySettings?: CreateInformationVisibilitySettings;
}

export interface SeasonsIncentiveAdminCreateManyBudgetComponentsParams {
  budgetBucketId: string;
  createManyBucketComponents?: CreateManyBucketComponents;
}

export interface SeasonsIncentiveAdminCreateMembersParams {
  createMember?: CreateMember;
}

export interface SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams {
  seasonId: string;
  createOrganisationInformationSnapshot?: CreateOrganisationInformationSnapshot;
}

export interface SeasonsIncentiveAdminCreatePlanSettingsParams {
  planId: string;
  createPlanSettings?: CreatePlanSettings;
}

export interface SeasonsIncentiveAdminCreatePlansParams {
  createPlan?: CreatePlan;
}

export interface SeasonsIncentiveAdminCreatePublicationSettingsParams {
  seasonId: string;
  createPublicationSettings?: CreatePublicationSettings;
}

export interface SeasonsIncentiveAdminCreateSeasonsParams {
  createSeason?: CreateSeason;
}

export interface SeasonsIncentiveAdminCreateSimulationParams {
  seasonsSimulationsCreateSimulation?: SeasonsSimulationsCreateSimulation;
}

export interface SeasonsIncentiveAdminDeleteBudgetComponentsParams {
  budgetBucketId: string;
}

export interface SeasonsIncentiveAdminDeleteCandidatePoolsParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminDeleteMembersParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminDeletePlanSettingsParams {
  id: string;
  planId: string;
}

export interface SeasonsIncentiveAdminDeletePlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteSeasonsParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteSimulationSettingsParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminDuplicateSeasonsParams {
  id: string;
  duplicateIncentiveSeason?: DuplicateIncentiveSeason;
}

export interface SeasonsIncentiveAdminExportEmployeeCandidatesParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  fileName?: string;
}

export interface SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminExportSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetBudgetBucketsParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetBudgetBucketsPlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetByIdRecordsParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsIncentiveAdminGetEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: Array<string>;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetMembersParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetOrganisationSnapshotsParams {
  seasonId: string;
  id: string;
}

export interface SeasonsIncentiveAdminGetPlanPopulationPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetPlanRecordsPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetPlanSettingsParams {
  planId: string;
}

export interface SeasonsIncentiveAdminGetPlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetPublicationSettingsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetRecordsParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams {
  gid?: string;
}

export interface SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams {
  id: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryTemplateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminGetSeasonSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetSeasonsParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetSimulationParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminGetSnapshotSeasonsParams {
  id: string;
  employeeId: string;
}

export interface SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams {
  snapshotId: string;
  updateEmployeeSnapshotPartial?: UpdateEmployeeSnapshotPartial;
}

export interface SeasonsIncentiveAdminPrePublishSimulationPublicationsParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsIncentiveAdminPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsIncentiveAdminQueryCandidatePoolsParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminQueryEmployeeCandidatesParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsIncentiveAdminQueryEmployeeSnapshotsParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryFieldValuesRecordsParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryMembersParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryOrganisationSnapshotsParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: Array<string>;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams {
  seasonId: string;
  seasonId2: string;
  queryOrgCode?: string;
}

export interface SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryPlansParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsIncentiveAdminQuerySeasonsParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsIncentiveAdminQuerySimulationParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminRecalculatePlanPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminSavePlanPopulationsParams {
  id: string;
}

export interface SeasonsIncentiveAdminSaveSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminSimulatePlanPopulationsParams {
  id: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminSimulateSeasonPopulationsParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminUnPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  unPublishSimulation?: UnPublishSimulation;
}

export interface SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams {
  updateSnapshotBenchmarkValues?: UpdateSnapshotBenchmarkValues;
}

export interface SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams {
  budgetBucketId: string;
  updateManyBucketComponents?: UpdateManyBucketComponents;
}

export interface SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams {
  budgetBucketId: string;
  updateBucketComponent?: UpdateBucketComponent;
}

export interface SeasonsIncentiveAdminUpdateBudgetBucketsParams {
  id: string;
  updateBudgetBucket?: UpdateBudgetBucket;
}

export interface SeasonsIncentiveAdminUpdateCandidatePoolsParams {
  id: string;
  updateCandidatePool?: UpdateCandidatePool;
}

export interface SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams {
  updateEmployeeSnapshot?: UpdateEmployeeSnapshot;
}

export interface SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  updateInformationVisibilitySettings?: UpdateInformationVisibilitySettings;
}

export interface SeasonsIncentiveAdminUpdateManyBudgetBucketsParams {
  updateManyBudgetBuckets?: UpdateManyBudgetBuckets;
}

export interface SeasonsIncentiveAdminUpdateMembersParams {
  updateMember?: UpdateMember;
}

export interface SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams {
  seasonId: string;
  id: string;
  updateOrganisationInformationSnapshot?: UpdateOrganisationInformationSnapshot;
}

export interface SeasonsIncentiveAdminUpdatePlanSettingsParams {
  id: string;
  planId: string;
  updatePlanSettings?: UpdatePlanSettings;
}

export interface SeasonsIncentiveAdminUpdatePlansParams {
  id: string;
  updatePlan?: UpdatePlan;
}

export interface SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams {
  seasonId: string;
  updatePublicationSettings?: UpdatePublicationSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams {
  seasonId: string;
  updateCommunicationSettings?: UpdateCommunicationSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonSettingsParams {
  setSeasonSettings?: SetSeasonSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonsParams {
  updateSeason?: UpdateSeason;
}

export interface SeasonsIncentiveAdminUpdateSimulationParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulation?: SeasonsSimulationsUpdateSimulation;
}

export interface SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams {
  seasonId: string;
  simulationId: string;
  updateSimulationMembers?: UpdateSimulationMembers;
}

@Injectable({
  providedIn: 'root'
})
export class SeasonsIncentiveAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Assigns a Kpi Detail to given Record
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    this.checkRequired('assignKpiDetailsToRecordRecords', { recordId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/individual-values`,
      accepts: [],
      body: requestParameters?.assignMissingIndividualIncentive,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCalculationStatus>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminCalculateManySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateManySimulations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminCalculateSimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/plans/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsIncentiveAdminCreateBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminCreateInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsIncentiveAdminCreateManyBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminCreateOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsIncentiveAdminCreatePlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminCreatePublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsCreateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsIncentiveAdminDeleteBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminDeleteCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsIncentiveAdminDeleteEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminDeleteMembers', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminDeleteOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsIncentiveAdminDeletePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminDeletePlans', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminDeleteSeasons', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminDeleteSimulationSettings', { id, seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminDuplicateSeasons', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.duplicateIncentiveSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminExportEmployeeCandidates', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/employee-candidates/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        SeasonId: seasonId,
        RecordIds: requestParameters?.recordIds,
        State: requestParameters?.state,
        Filename: requestParameters?.filename
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminExportOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        fileName: requestParameters?.fileName
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExportEmployeePopulationResultDto>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExportEmployeePopulationResultDto>>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExportEmployeePopulationResultDto>>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminExportSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModel>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BudgetBucketModel>>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BudgetBucketModel>>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetBudgetBucketsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RecordModel>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RecordModel>>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RecordModel>>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    this.checkRequired('seasonsIncentiveAdminGetByIdRecords', { recordId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsIncentiveAdminGetEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetMembers', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetMySeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { memberId: requestParameters?.memberId, gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetOfSeasonPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetOrganisationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetPlanPopulationPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetPlanRecordsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsIncentiveAdminGetPlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetPublicationSettings', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSeasonOverview>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSeasonOverview>>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSeasonOverview>>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/members/overview`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetSeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.State': requestParameters?.queryState,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.TemplateType': requestParameters?.queryTemplateType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.MeasurementDate': requestParameters?.queryMeasurementDate,
        'Query.MeritTitle': requestParameters?.queryMeritTitle,
        'Query.EquityTitle': requestParameters?.queryEquityTitle,
        'Query.EquitySubTitle': requestParameters?.queryEquitySubTitle,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.LineManagerFirstName': requestParameters?.queryLineManagerFirstName,
        'Query.LineManagerLastName': requestParameters?.queryLineManagerLastName,
        'Query.CompanyManagerFirstName': requestParameters?.queryCompanyManagerFirstName,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CompanyManagerLastName': requestParameters?.queryCompanyManagerLastName,
        'Query.TemplateName': requestParameters?.queryTemplateName,
        'Query.WorkflowType': requestParameters?.queryWorkflowType,
        'Query.AutoApprove': requestParameters?.queryAutoApprove,
        'Query.ApprovalRequired': requestParameters?.queryApprovalRequired,
        'Query.LetterState': requestParameters?.queryLetterState,
        'Query.ProcessState': requestParameters?.queryProcessState,
        'Query.ExportState': requestParameters?.queryExportState,
        'Query.PayrollState': requestParameters?.queryPayrollState,
        'Query.MeritRelevancy': requestParameters?.queryMeritRelevancy,
        'Query.ApprovedByCompanyManager': requestParameters?.queryApprovedByCompanyManager,
        'Query.AllocationWorkflowType': requestParameters?.queryAllocationWorkflowType,
        'Query.ReadyToPayroll': requestParameters?.queryReadyToPayroll,
        'Query.EquityRelevancy': requestParameters?.queryEquityRelevancy,
        'Query.HasOtpIncrease': requestParameters?.queryHasOtpIncrease,
        'Query.IsOtpOnly': requestParameters?.queryIsOtpOnly,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.LocalCurrency': requestParameters?.queryLocalCurrency,
        'Query.ProposalAmount': requestParameters?.queryProposalAmount,
        'Query.ProposalAmountInEuro': requestParameters?.queryProposalAmountInEuro,
        'Query.ProposalDate': requestParameters?.queryProposalDate,
        'Query.ProposalState': requestParameters?.queryProposalState,
        'Query.SpecialPaymentReason': requestParameters?.querySpecialPaymentReason,
        'Query.SpecialPaymentCompensationType': requestParameters?.querySpecialPaymentCompensationType,
        'Query.TemplateLetterName': requestParameters?.queryTemplateLetterName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetSeasonSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminGetSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminGetSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Snapshot>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Snapshot>>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Snapshot>>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('seasonsIncentiveAdminGetSnapshotSeasons', { id, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationSnapshotTreeItem>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminGetTreeOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { parentOrgCode: requestParameters?.parentOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsIncentiveAdminPartialUpdateEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshotPartial,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        PositionName: requestParameters?.positionName,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        MercerJobCode: requestParameters?.mercerJobCode,
        PositionClass: requestParameters?.positionClass,
        NewPositionClass: requestParameters?.newPositionClass,
        OriginalProposedPositionClass: requestParameters?.originalProposedPositionClass,
        PositionType: requestParameters?.positionType,
        CountryIsoCode: requestParameters?.countryIsoCode,
        IncumbentGid: requestParameters?.incumbentGid,
        IncumbentFirstName: requestParameters?.incumbentFirstName,
        IncumbentLastName: requestParameters?.incumbentLastName,
        IncumbentCountryPlaceOfAction: requestParameters?.incumbentCountryPlaceOfAction,
        ValidationManagerId: requestParameters?.validationManagerId,
        ValidationManagerGid: requestParameters?.validationManagerGid,
        ValidationManagerFirstName: requestParameters?.validationManagerFirstName,
        ValidationManagerLastName: requestParameters?.validationManagerLastName,
        ValidationState: requestParameters?.validationState,
        PlacementState: requestParameters?.placementState,
        NewHireState: requestParameters?.newHireState,
        IsLocked: requestParameters?.isLocked,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        IncumbentAre: requestParameters?.incumbentAre,
        Tag: requestParameters?.tag,
        WasPromoted: requestParameters?.wasPromoted,
        IsTransferred: requestParameters?.isTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CandidatePoolModel>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CandidatePoolModel>>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CandidatePoolModel>>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionEvaluationCandidate>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionEvaluationCandidate>>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionEvaluationCandidate>>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/employee-candidates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/employee-candidates/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        SeasonId: requestParameters?.seasonId,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        CandidatePoolTitle: requestParameters?.candidatePoolTitle,
        OrgCode: requestParameters?.orgCode,
        Gender: requestParameters?.gender,
        OrgLevel: requestParameters?.orgLevel,
        MercerPositionClass: requestParameters?.mercerPositionClass,
        IsPlaced: requestParameters?.isPlaced,
        IsShortlisted: requestParameters?.isShortlisted
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('seasonsIncentiveAdminQueryFieldValuesRecords', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/records/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationInformationSnapshot>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationInformationSnapshot>>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationInformationSnapshot>>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritInformationVisibilitySettings>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritInformationVisibilitySettings>>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritInformationVisibilitySettings>>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminQueryInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationSnapshot>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminQueryOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.OrganisationId': requestParameters?.queryOrganisationId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.ParentOrgCode': requestParameters?.queryParentOrgCode,
        'Query.HeadId': requestParameters?.queryHeadId,
        'Query.HeadGid': requestParameters?.queryHeadGid,
        'Query.HeadName': requestParameters?.queryHeadName,
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.AdditionalLineOne': requestParameters?.queryAdditionalLineOne,
        'Query.AdditionalLineTwo': requestParameters?.queryAdditionalLineTwo,
        'Query.AdditionalLineThree': requestParameters?.queryAdditionalLineThree,
        'Query.AdditionalLineFour': requestParameters?.queryAdditionalLineFour,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.OrgType': requestParameters?.queryOrgType,
        'Query.OrgLevelA': requestParameters?.queryOrgLevelA,
        'Query.OrgLevelB': requestParameters?.queryOrgLevelB,
        'Query.OrgLevelC': requestParameters?.queryOrgLevelC,
        'Query.OrgLevelD': requestParameters?.queryOrgLevelD,
        'Query.NumberOfEmployees': requestParameters?.queryNumberOfEmployees,
        'Query.HeadFirstname': requestParameters?.queryHeadFirstname,
        'Query.HeadLastname': requestParameters?.queryHeadLastname,
        'Query.HeadPAOrgCode': requestParameters?.queryHeadPAOrgCode,
        'Query.HeadPlaceOfAction': requestParameters?.queryHeadPlaceOfAction,
        'Query.HeadMercerJobCode': requestParameters?.queryHeadMercerJobCode,
        'Query.HeadMercerPositionClass': requestParameters?.queryHeadMercerPositionClass,
        'Query.HeadManagementGroup': requestParameters?.queryHeadManagementGroup,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.Revenue': requestParameters?.queryRevenue,
        'Query.HeadCount': requestParameters?.queryHeadCount,
        'Query.RevenueOrgSize': requestParameters?.queryRevenueOrgSize,
        'Query.HeadCountOrgSize': requestParameters?.queryHeadCountOrgSize,
        'Query.ShowOrganisationsWithoutOrgInfos': requestParameters?.queryShowOrganisationsWithoutOrgInfos,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSnapshot>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/snapshots/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        MeritSeasonId: requestParameters?.meritSeasonId,
        Search: requestParameters?.search,
        Directs: requestParameters?.directs,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const seasonId2 = requestParameters?.seasonId2;
    this.checkRequired('seasonsIncentiveAdminQueryParentsOrganisationSnapshots', { seasonId, seasonId2 });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: seasonId2, 'Query.OrgCode': requestParameters?.queryOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlanWithMissingIndividualValues>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlanWithMissingIndividualValues>>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlanWithMissingIndividualValues>>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.KpiId': requestParameters?.queryKpiId,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.RecordStartdate': requestParameters?.queryRecordStartdate,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlan>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlan>>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlan>>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BucketComponentsPossibilities>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BucketComponentsPossibilities>>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BucketComponentsPossibilities>>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/budget-bucket/component-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSeason>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSeason>>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSeason>>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        SeasonType: requestParameters?.seasonType,
        SimulationState: requestParameters?.simulationState,
        'Query.ManagerEndDateAt': requestParameters?.queryManagerEndDateAt,
        'Query.PartnerEndDateAt': requestParameters?.queryPartnerEndDateAt,
        'Query.SeasonType': requestParameters?.querySeasonType,
        'Query.SimulationState': requestParameters?.querySimulationState
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminQuerySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateCandidatePools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/candidate-pools/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const parentSettingId = requestParameters?.parentSettingId;
    this.checkRequired('seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations', {
      simulationId,
      parentSettingId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminRecalculatePlanPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminSavePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminSaveSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PopulationCreatedResultPagedDto>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminSimulatePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings', { settingsId, simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeePopulationCreatedResultPagedDto>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminSimulateSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, export: requestParameters?._export },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminUnPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminUnPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.unPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/snapshots/benchmarks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSnapshotBenchmarkValues,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsIncentiveAdminUpdateBucketComponentBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminUpdateBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBudgetBucket,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminUpdateCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminUpdateInformationVisibilitySettings', { settingsId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/budget-bucket/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBudgetBuckets,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminUpdateOrganisationInformationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsIncentiveAdminUpdatePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsIncentiveAdminUpdatePlans', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsIncentiveAdminUpdateSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCommunicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setSeasonSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/incentive/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonsSimulationsSimulation>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonsSimulationsSimulation>>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonsSimulationsSimulation>>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminUpdateSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsUpdateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsIncentiveAdminUpdateSimulationMembersSimulation', { seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSimulationMembers,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
